import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import './Fcontact.css';
import { useForm } from 'react-hook-form';
import axios from "axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const API_PATH = "http://www.eyeofchina.co.za/services/sendmail.php";
toast.configure()

const Fcontact = () => {

    const [state, setState] = useState({mailSent: false, error: null, isDisabled: false})
    const { register, handleSubmit } = useForm();
    const onSubmit = (data) => {
        console.log(data);
       

    //    data.preventDefault();
        axios({
          method: "post",
          url: `${API_PATH}`,
          headers: { "content-type": "application/json" },
          data: data,
        })
          .then((result) => {
              console.log(result)
            setState({
             mailSent: result.data.sent,
             error: null,
             isDisabled: true,
             //mailSent: true
            });
            notify();
            // clearForms();
            // console.log("clear my form" );
          })
        //   .catch(function (error) {
        //     if (error.response) {
        //       console.log(error.response.data);
        //       console.log(error.response.status);
        //       console.log(error.response.headers);
        //     }
        //   });
          .catch((error) => setState({ error: error.message, mailSent: false }));
        console.log(
              "that is the messages am sending that i cant see",
        //   this.props.mailSent
        );
    }

    const notify = () => {
        toast.success('Your form has been sent successful!')
    }


    return (
        <div>
            <div className="formbox">
                <Form autoComplete="off"  onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
                    <Form.Group controlId="fullname">
                        <Form.Control className="custom-form" type="text" placeholder="Full Name" name="fullname" size="lg" ref={register} />
                    </Form.Group>

                    <Form.Group controlId="email">
                        <Form.Control className="custom-form" type="email" placeholder="E-mail" name="email" size="lg" ref={register} />
                    </Form.Group>

                    <Form.Group controlId="company">
                        <Form.Control className="custom-form" type="text" placeholder="Company" name="company" size="lg" ref={register} />
                    </Form.Group>

                    <Form.Group controlId="contact">
                        <Form.Control className="custom-form" type="text" placeholder="Contact Number" name="contact" size="lg" ref={register} />
                    </Form.Group>

                    <Form.Group controlId="location">
                        <Form.Control className="custom-form" as="select" size="lg"  name="location" ref={register} >
                            <option>Select your location</option>
                            <option>China</option>
                            <option>South Africa</option>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="category">
                        <Form.Control className="custom-form" as="select" size="lg"  name="category" ref={register} >
                            <option>Select Category</option>
                            <option>Electronics</option>
                            <option>Mechinery</option>
                            <option>Tools</option>
                            <option>Beauty & Personal Care</option>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="description">
                        <Form.Control className="custom-form" as="textarea" rows={3} placeholder="Description of the product" name="description" size="lg" ref={register} />
                    </Form.Group>

                    <Form.Group>
                        <label htmlFor="fileupload" className="custom-file-upload">
                            <i className="fa fa-cloud-upload"></i> Custom Upload
                        </label>
                        <input id="fileupload" type="file" name="fileupload" ref={register} />
                         {/* <Form.File className="custom-file-upload" id="exampleFormControlFile1" label="Up load Sample image" /> <i class="fa fa-cloud-upload"></i> */}
                     </Form.Group> 

{/* 
                    <Form.Group>
                        <label htmlFor="fileupload">test</label>
                        <input id="myfile" type="file" name="myfile" ref={register} />
                    </Form.Group>  */}





                    <Button variant="danger" type="submit" disabled={state.isDisabled}>
                        Send
                    </Button>

                    {/* <Button onClick={notify}>
                        Notify
                    </Button> */}
                </Form>
            </div>


        </div>
    );
};

export default Fcontact;